"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_network(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ac1d4df6-cfb1-4508-a55c-f4e1e064e061",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 158.18"
  }, props), /*#__PURE__*/React.createElement("title", null, "network-signal"), /*#__PURE__*/React.createElement("g", {
    id: "e62c86c2-c208-4774-aa7e-a45c5c9aead8",
    "data-name": "network_1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "108.09 154.18 80 58.18 51.91 154.18 95.83 112.28",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "51.91 154.18 80 58.18 108.09 154.18 64.16 112.31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.95,52.62a30.46,30.46,0,0,0,0,43.12",
    transform: "translate(-16 -17.82)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,37.22a52.21,52.21,0,0,0,0,73.93",
    transform: "translate(-16 -17.82)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.73,21.82a74,74,0,0,0,0,104.73",
    transform: "translate(-16 -17.82)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,52.62a30.46,30.46,0,0,1,0,43.12",
    transform: "translate(-16 -17.82)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.66,37.22a52.21,52.21,0,0,1,0,73.93",
    transform: "translate(-16 -17.82)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.27,21.82a74,74,0,0,1,0,104.73",
    transform: "translate(-16 -17.82)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _default = ic_network;
exports.default = _default;